import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5485a91a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sell_main_top" }
const _hoisted_2 = { class: "sell_main_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "팔기 현황", -1))
const _hoisted_4 = { class: "main_content" }
const _hoisted_5 = { class: "deallist_container" }
const _hoisted_6 = {
  class: "empty_box blue_bg",
  style: {"background-image":"url('/assets/image/asset_bg_img.png')"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "box_title" }, " 팔기 등록하신 자산이 없습니다 "),
  /*#__PURE__*/_createElementVNode("div", { class: "box_info" }, " 내가 가진 주식이나 지분을 팔 수 있어요 ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "angel_man",
    src: "/assets/image/orange_richie.png",
    srcset: "/assets/image/orange_richie@2x.png 2x,/assets/image/orange_richie@3x.png 3x"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "arrow_b",
                src: "/assets/icon/btn_back.png",
                srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x",
                onClick: _cache[0] || (_cache[0] = () => { _ctx.router.go(-1) })
              }),
              _hoisted_3
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("div", {
                  class: "box_btn",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.router.push({name : 'MyAsset', params: {scroll : 'own'}}))
                }, " 지분 보유 현황 보기 > ")
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}